enum SHARING_ACTIONS {
  SET_ACCESS_FOR_MODULE_START = 'SET_ACCESS_FOR_MODULE_START',
  SET_ACCESS_FOR_MODULE_FINISH = 'SET_ACCESS_FOR_MODULE_FINISH',
  SET_EXAM_FOR_STUDENT_START = 'SET_EXAM_FOR_STUDENT_START',
  SET_EXAM_FOR_STUDENT_FINISH = 'SET_EXAM_FOR_STUDENT_FINISH',
  SET_STUDENT_GRANT_FOR_ALL_MODULES_START = 'SET_STUDENT_GRANT_FOR_ALL_MODULES_START',
  SET_STUDENT_GRANT_FOR_ALL_MODULES_FINISH = 'SET_STUDENT_GRANT_FOR_ALL_MODULES_FINISH',
  SET_LECTURER_GRANT_FOR_MODULE_START = 'SET_LECTURER_GRANT_FOR_MODULE_START',
  SET_LECTURER_GRANT_FOR_MODULE_FINISH = 'SET_LECTURER_GRANT_FOR_MODULE_FINISH',
  SHARE_EXAMS_FOR_STUDENT_START = 'SHARE_EXAMS_FOR_STUDENT_START',
  SHARE_EXAMS_FOR_STUDENT_FINISH = 'SHARE_EXAMS_FOR_STUDENT_FINISH',
  GRANT_FOR_ALL_STUDENTS_IN_PROGRESS_SET = 'GRANT_FOR_ALL_STUDENTS_IN_PROGRESS_SET',
  GRANT_FOR_ALL_STUDENTS_IN_PROGRESS_CLEAR = 'GRANT_FOR_ALL_STUDENTS_IN_PROGRESS_CLEAR',
}

export default SHARING_ACTIONS;
